export default __webpack_public_path__ + "static/theFinalWord-12b8c75afab255b450f056d0009e14d5.png";